module.exports = __webpack_public_path__ + "fonts/Gilroy-UltraLight.22b0d1f5.woff";